const initialState = [
    {
        id: 1,
        title: 'Boost your conversion rate easily',
        category: 'javascript',
        feature_image: 'https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
        author_name: 'Learn with Sumit',
        author_avator: 'https://avatars.githubusercontent.com/u/73503432?v=4',
        publish_date: '11 Jul, 2022'
    },
    {
        id: 2,
        title: 'How to use search engine optimization to drive sales',
        category: 'python',
        feature_image: 'https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
        author_name: 'Yanis Ahmed',
        author_avator: 'https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50',
        publish_date: '11 Jul, 2022'
    },
    {
        id: 3,
        title: 'Improve your customer experience',
        category: 'javascript',
        feature_image: 'https://images.unsplash.com/photo-1571505280193-4b4e29712a77?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
        author_name: 'Learn with Sumit',
        author_avator: 'https://avatars.githubusercontent.com/u/73503432?v=4',
        publish_date: '11 Jul, 2022'
    },
    {
        id: 4,
        title: 'Deep Learning Stratragy',
        category: 'article',
        feature_image: 'https://images.unsplash.com/photo-1517281862878-d312fe477d71?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8ZGVlcCUyMGxlYXJuaW5nfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60',
        author_name: 'Yanis Ahmed',
        author_avator: 'https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50',
        publish_date: '11 Jul, 2022'
    },
    {
        id: 5,
        title: 'Learn Readuc From Screatch',
        category: 'article',
        feature_image: 'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8bGVhcm58ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60',
        author_name: 'Learn with Sumit',
        author_avator: 'https://avatars.githubusercontent.com/u/73503432?v=4',
        publish_date: '11 Jul, 2022'
    },
    {
        id: 6,
        title: 'Crazy Driving Mindset',
        category: 'article',
        feature_image: 'https://images.unsplash.com/photo-1507413245164-6160d8298b31?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
        author_name: 'Yanis Ahmed',
        author_avator: 'https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50',
        publish_date: '11 Jul, 2022'
    },
    {
        id: 7,
        title: 'Boost your conversion rate',
        category: 'article',
        feature_image: 'https://images.unsplash.com/photo-1539141086657-b9cc8d93ad3c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1077&q=80',
        author_name: 'Learn with Sumit',
        author_avator: 'https://avatars.githubusercontent.com/u/73503432?v=4',
        publish_date: '11 Jul, 2022'
    },
    {
        id: 8,
        title: 'Miracle Moring',
        category: 'article',
        feature_image: 'https://images.unsplash.com/12/sun-trees.jpg?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1340&q=80',
        author_name: 'Yanis Ahmed',
        author_avator: 'https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50',
        publish_date: '11 Jul, 2022'
    }

]

export default initialState;